import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconInformationGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M22.1 34.55h4.1V22h-4.1Zm1.9-15.5q1.05 0 1.725-.675T26.4 16.7q0-1.1-.7-1.775-.7-.675-1.7-.675-1.05 0-1.725.675T21.6 16.65q0 1.05.7 1.725t1.7.675Zm0 26.2q-4.4 0-8.275-1.65T8.95 39.05q-2.9-2.9-4.55-6.75T2.75 24q0-4.45 1.65-8.325 1.65-3.875 4.55-6.75t6.75-4.55Q19.55 2.7 24 2.7q4.45 0 8.325 1.675 3.875 1.675 6.75 4.55t4.55 6.75Q45.3 19.55 45.3 24q0 4.45-1.675 8.3-1.675 3.85-4.55 6.725-2.875 2.875-6.75 4.55Q28.45 45.25 24 45.25Zm.05-4.7q6.85 0 11.675-4.825Q40.55 30.9 40.55 23.95q0-6.85-4.825-11.675Q30.9 7.45 24 7.45q-6.9 0-11.725 4.825Q7.45 17.1 7.45 24q0 6.9 4.825 11.725Q17.1 40.55 24.05 40.55ZM24 24Z"
        fill={fillColor}
      />
    </g>
  );
};

export const IconInformationSvg: React.FC<SvgProps> = (props) => {
  const size = props.size ?? 48;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      width={size}
      viewBox="0 0 48 48"
      {...(props.svg ?? {})}
    >
      <IconInformationGroup {...props} />
    </svg>
  );
};
